var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Bubble',{staticClass:"edit-bubble",attrs:{"type":"dashed","element":"button"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('Icon',{attrs:{"name":"edit"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }